/**
 * Build-time configuration. Always read through `process.env` (set by vite.config.ts's
 * `define`, from CodeBuild environment variables in deployed builds, or from
 * .env.local in development) -- never `import.meta.env`, never a `VITE_` prefix.
 */
export const env = {
  apiUrl: (process.env.API_URL ?? "").replace(/\/$/, ""),
  cognitoRegion: process.env.COGNITO_REGION ?? "",
  cognitoUserPoolId: process.env.COGNITO_USER_POOL_ID ?? "",
  cognitoClientId: process.env.COGNITO_CLIENT_ID ?? "",
  baseDomain: process.env.BASE_DOMAIN ?? "",
};

/** The settings without which the app cannot reach its API or sign anyone in. */
export function missingSettings(settings = env): string[] {
  const required: [string, string][] = [
    ["API_URL", settings.apiUrl],
    ["COGNITO_REGION", settings.cognitoRegion],
    ["COGNITO_USER_POOL_ID", settings.cognitoUserPoolId],
    ["COGNITO_CLIENT_ID", settings.cognitoClientId],
  ];
  return required.filter(([, value]) => !value).map(([name]) => name);
}
